/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_1_CommitmentInputs */

const en_privacy_section_1_commitment = /** @type {(inputs: Privacy_Section_1_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We are committed to protecting your privacy and handling your personal data in accordance with the General Data Protection Regulation (GDPR) and applicable Latvian data protection laws.`)
};

const lv_privacy_section_1_commitment = /** @type {(inputs: Privacy_Section_1_CommitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mēs esam apņēmušies aizsargāt Jūsu privātumu un apstrādāt Jūsu personas datus saskaņā ar Vispārīgo datu aizsardzības regulu (GDPR) un piemērojamiem Latvijas datu aizsardzības likumiem.`)
};

/**
* | output |
* | --- |
* | "We are committed to protecting your privacy and handling your personal data in accordance with the General Data Protection Regulation (GDPR) and applicable L..." |
*
* @param {Privacy_Section_1_CommitmentInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_1_commitment = /** @type {((inputs?: Privacy_Section_1_CommitmentInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_1_CommitmentInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_1_commitment(inputs)
	return en_privacy_section_1_commitment(inputs)
});